import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ProductosPage } from '../pages/productos/productos';
import  { ArticuloPage } from '../pages/articulo/articulo';
import { PerfilPage } from '../pages/perfil/perfil';
import { LoginPage } from '../pages/login/login';
import { RegistrarPage } from '../pages/registrar/registrar';

import { HeaderComponent } from '../components/header/header';
import { CarritoPage } from '../pages/carrito/carrito';
import { PagoPage } from '../pages/pago/pago';
import { HttpModule }    from '@angular/http';
import { FacturaPage } from '../pages/factura/factura';
import { ValidarPage } from "../pages/validar/validar";
import { CorreoPage } from '../pages/correo/correo';
import { NewPage } from '../pages/new/new';
import { ReparacionPage } from '../pages/reparacion/reparacion';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    HeaderComponent,
    ProductosPage,
    ArticuloPage,
    LoginPage,
    PerfilPage,
    RegistrarPage,
    CarritoPage,
    PagoPage,
    FacturaPage,
    ValidarPage,
    CorreoPage,
    NewPage,
    ReparacionPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    HeaderComponent,
    ProductosPage,
    ArticuloPage,
    LoginPage,
    PerfilPage,
    RegistrarPage,
    CarritoPage,
    PagoPage,
    FacturaPage,
    ValidarPage,
    CorreoPage,
    NewPage,
    ReparacionPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts